import {Navigate} from 'react-router-dom';
import {useCustomerContext} from '../../lib/context/customerContext';

// Route guard - composes with the existing PrivateRoute (auth/idle-timer
// logic stays untouched there). Redirects to /unauthorized when the user
// lacks the required permission(s). Renders nothing while permsLoading is
// true, to avoid a flash-redirect before the UserPermissions query resolves.
export const RequirePermission = ({code, any, redirectPath = '/unauthorized', children}) => {
  const {hasPermission, hasAnyPermission, permsLoading} = useCustomerContext();

  if (permsLoading) return null;

  const allowed = any ? hasAnyPermission(any) : hasPermission(code);
  return allowed ? children : <Navigate to={redirectPath} replace />;
};

export default RequirePermission;
